<template>
  <v-container fluid>
    <v-row align="center">
      <v-col cols="12" md="auto">
        <BaseBreadcrumbs :crumbs="crumbs" class="px-0 py-0"/> 
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="9" md="8">
        <v-chip
          class="ma-2"
          color="primary"
          outlined
          pill
        >
          <v-icon left>
            mdi-account-outline
          </v-icon>
          Chuyên gia: {{item.tengoi}}
        </v-chip>
        <v-chip
          v-if="item.branch"
          class="ma-2"
          color="primary"
          outlined
          pill
        >
          <v-icon left>
            mdi-sitemap
          </v-icon>
          Lĩnh vực: {{item.branch.name}}
        </v-chip>
        <v-chip
          class="ma-2"
          color="primary"
          outlined
          pill
        >
          <v-icon left>
            mdi-phone
          </v-icon>
          Số điện thoại: {{item.dien_thoai}}
        </v-chip>
      </v-col>
      <v-col cols="3" md="4" class="text-right">
        <v-chip
          class="ma-2"
          color="primary"
          pill
          v-on:click="showDialog()"
        >
          <v-icon left medium>mdi-help-circle-outline</v-icon>
          Hỏi chuyên gia
        </v-chip>
      </v-col>
    </v-row>
    <Support 
      class="mt-2"
      :filter="false" 
      :expertId="parseInt(item.id)"
    />
    <SupportForm 
      :showDialog="dialog" 
      :item="qasItem" 
      :expertId="parseInt(item.id)"
      @confirmed="onConfirmed" 
      @cancelled="onCancelled"
    />
  </v-container>
</template>
<script>
  import Support from '@/views/public/supports/Support';
  import SupportForm from '@/views/admin/supports/Form';
  import { mapGetters } from 'vuex';
  import BaseBreadcrumbs from '@/components/base/BaseBreadcrumbs';
  export default {
    components: {
      Support,
      SupportForm,
      BaseBreadcrumbs
    },
    data: () => ({
      loading: false,
      crumbs: [],
      dialog: false,
      map:{
        lat:0,
        lng: 0
      },
      messageDialog: false,
      activeTab: null,
      model: 0,
      products: [],
      item: {},
      qasItem: {}
    }),
    computed: {
      ...mapGetters([
        'isLogged'
      ])
    },
    mounted() {
      this.initialize();
      this.crumbs = [
        {
          text: 'Trang chủ',
          disabled: false,
          href: '/',
        },
        {
          text: 'Hỏi đáp kỹ thuật',
          disabled: false,
          href: '/supports',
        },
        {
          text: 'Chuyên gia',
          disabled: true
        }
      ];
    },
    methods: {
      initialize(){
        this.loading=true;
        axios.get(`api/v1/public/experts/${this.$route.params.id}`)
          .then(response => {
            this.item = response.data;
            this.loading=false;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      showDialog(item=null){
        this.qasItem = item||{};
        this.dialog = true;
      },
      onConfirmed(item) {
        this.dialog = false;
        this.dialogReply = false;
        this.initialize();
      },
      onCancelled () {
        this.dialog = false;
        this.dialogReply = false;
      },
    }
  }
</script>
<style scoped>
  .v-card--flat {
    box-shadow: 0 0 0 0 rgba(0,0,0,.2),0 0 0 0 rgba(0,0,0,.14),0 0 0 0 rgba(0,0,0,.12) !important;
  }
</style>